import React, { useState } from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent } from '../components/Card';
import { Network, Users, Eye } from 'lucide-react';
import { Globe, FileSearch, Megaphone } from 'lucide-react';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../components/Table';
import { Avatar, AvatarFallback } from '../components/Avatar';
import { Badge } from '../components/Badge';
import { Button } from '../components/Button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/Dialog';
import { toast } from 'sonner';
import { ActorRelationshipGraph } from '../components/dashboard/ActorRelationshipGraph';
import { RelatedWorkflow } from '../components/dashboard/RelatedWorkflow';
const actors = [{
  id: 1,
  name: 'Budi Santoso',
  handle: '@budis_pengamat',
  platform: 'X',
  influence: 92,
  status: 'ORGANIK',
  followers: '1.2M',
  sentiment: 'NEGATIF',
  cluster: 'Pengamat Politik',
  topic: 'Kebijakan Pangan'
}, {
  id: 2,
  name: 'Info Daerah Update',
  handle: '@infodaerah_up',
  platform: 'IG',
  influence: 88,
  status: 'TERKOORDINASI',
  followers: '850K',
  sentiment: 'NEGATIF',
  cluster: 'Buzzer Cluster A',
  topic: 'Bansos'
}, {
  id: 3,
  name: 'Relawan Maju',
  handle: '@relawan_maju',
  platform: 'FB',
  influence: 85,
  status: 'TERKOORDINASI',
  followers: '500K',
  sentiment: 'POSITIF',
  cluster: 'Pro-Government',
  topic: 'MBG'
}, {
  id: 4,
  name: 'Siti Aminah',
  handle: '@sitiaminah_news',
  platform: 'TikTok',
  influence: 78,
  status: 'ORGANIK',
  followers: '2.1M',
  sentiment: 'NETRAL',
  cluster: 'Independent',
  topic: 'Pangan'
}, {
  id: 5,
  name: 'Kritik Pedas',
  handle: '@kritik_pedas99',
  platform: 'X',
  influence: 75,
  status: 'TERKOORDINASI',
  followers: '120K',
  sentiment: 'NEGATIF',
  cluster: 'Buzzer Cluster B',
  topic: 'Pajak'
}, {
  id: 6,
  name: 'Tani Sejahtera',
  handle: '@tanisejahtera_id',
  platform: 'X',
  influence: 72,
  status: 'ORGANIK',
  followers: '340K',
  sentiment: 'NEGATIF',
  cluster: 'Petani',
  topic: 'Pupuk'
}, {
  id: 7,
  name: 'Sukma N.',
  handle: '@sukmaa.n',
  platform: 'TikTok',
  influence: 70,
  status: 'ORGANIK',
  followers: '890K',
  sentiment: 'POSITIF',
  cluster: 'Lifestyle',
  topic: 'MBG'
}, {
  id: 8,
  name: 'Berita Lokal Papua',
  handle: '@beritapapua_',
  platform: 'FB',
  influence: 68,
  status: 'ORGANIK',
  followers: '230K',
  sentiment: 'NEGATIF',
  cluster: 'Media Lokal',
  topic: 'Kunjungan VVIP'
}, {
  id: 9,
  name: 'Anti Hoaks ID',
  handle: '@anti_hoax_id',
  platform: 'X',
  influence: 65,
  status: 'ORGANIK',
  followers: '180K',
  sentiment: 'NETRAL',
  cluster: 'Fact-check',
  topic: 'Deepfake'
}, {
  id: 10,
  name: 'Buruh Bergerak',
  handle: '@buruh_bergerak',
  platform: 'X',
  influence: 62,
  status: 'TERKOORDINASI',
  followers: '95K',
  sentiment: 'NEGATIF',
  cluster: 'Buzzer Cluster C',
  topic: 'Upah Minimum'
}];
export function ActorNetwork() {
  const [selectedActor, setSelectedActor] = useState<(typeof actors)[0] | null>(null);
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-981">
      <PageHeader group="Intelijen Aktor" title="Actor Network Intelligence" description="Pemetaan aktor organik, buzzer terkoordinasi, dan klaster narasi yang mempengaruhi stabilitas nasional." icon={Network} data-id="element-982" />

      <ActorRelationshipGraph data-id="element-983" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-984">
        {[{
        l: 'Total Aktor Dipantau',
        v: '1,204',
        c: 'text-blue-500'
      }, {
        l: 'Aktor Berisiko Tinggi',
        v: '89',
        c: 'text-red-500'
      }, {
        l: 'Jaringan Terdeteksi',
        v: '12',
        c: 'text-amber-500'
      }, {
        l: 'Aktor Terverifikasi',
        v: '450',
        c: 'text-emerald-500'
      }].map(k => <Card key={k.l} className="bg-card border-border/50" data-id="element-985">
            <CardContent className="p-4" data-id="element-986">
              <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-987">
                {k.l}
              </p>
              <p className={`font-heading text-2xl font-bold mt-1 ${k.c}`} data-id="element-988">
                {k.v}
              </p>
            </CardContent>
          </Card>)}
      </div>

      <Card className="bg-card border-border/50" data-id="element-989">
        <CardContent className="p-4" data-id="element-990">
          <div className="flex items-center justify-between mb-4" data-id="element-991">
            <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-992">
              Actor Network
            </p>
            <p className="font-heading text-2xl font-bold mt-1" data-id="element-993">
              {actors.length}
            </p>
          </div>
          <div className="overflow-x-auto" data-id="element-994">
            <Table data-id="element-995">
              <TableHeader className="bg-muted/20" data-id="element-996">
                <TableRow className="border-border/50 hover:bg-transparent" data-id="element-997">
                  <TableHead className="font-mono text-[9px]" data-id="element-998">AKTOR</TableHead>
                  <TableHead className="font-mono text-[9px]" data-id="element-999">
                    PLATFORM
                  </TableHead>
                  <TableHead className="font-mono text-[9px]" data-id="element-1000">
                    FOLLOWERS
                  </TableHead>
                  <TableHead className="font-mono text-[9px]" data-id="element-1001">
                    INFLUENCE
                  </TableHead>
                  <TableHead className="font-mono text-[9px]" data-id="element-1002">
                    KLASTER
                  </TableHead>
                  <TableHead className="font-mono text-[9px]" data-id="element-1003">
                    TOPIK UTAMA
                  </TableHead>
                  <TableHead className="font-mono text-[9px]" data-id="element-1004">STATUS</TableHead>
                  <TableHead className="font-mono text-[9px]" data-id="element-1005">
                    SENTIMEN
                  </TableHead>
                  <TableHead className="font-mono text-[9px] text-right" data-id="element-1006">
                    AKSI
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-1007">
                {actors.map(a => <TableRow key={a.id} className="border-border/30 hover:bg-muted/10" data-id="element-1008">
                    <TableCell className="py-2" data-id="element-1009">
                      <div className="flex items-center gap-2" data-id="element-1010">
                        <Avatar className="size-7" data-id="element-1011">
                          <AvatarFallback className="text-[10px]" data-id="element-1012">
                            {a.name.substring(0, 2).toUpperCase()}
                          </AvatarFallback>
                        </Avatar>
                        <div data-id="element-1013">
                          <p className="text-xs font-bold leading-tight" data-id="element-1014">
                            {a.name}
                          </p>
                          <p className="font-mono text-[9px] text-muted-foreground" data-id="element-1015">
                            {a.handle}
                          </p>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell data-id="element-1016">
                      <span className="font-mono text-[10px] bg-muted px-1.5 py-0.5 rounded" data-id="element-1017">
                        {a.platform}
                      </span>
                    </TableCell>
                    <TableCell className="font-mono text-xs" data-id="element-1018">
                      {a.followers}
                    </TableCell>
                    <TableCell data-id="element-1019">
                      <div className="flex items-center gap-2" data-id="element-1020">
                        <div className="w-12 h-1 bg-muted rounded-full overflow-hidden" data-id="element-1021">
                          <div className="h-full bg-amber-500" style={{
                        width: `${a.influence}%`
                      }} data-id="element-1022" />
                        </div>
                        <span className="font-mono text-[10px]" data-id="element-1023">
                          {a.influence}
                        </span>
                      </div>
                    </TableCell>
                    <TableCell className="text-xs text-muted-foreground" data-id="element-1024">
                      {a.cluster}
                    </TableCell>
                    <TableCell className="text-xs" data-id="element-1025">{a.topic}</TableCell>
                    <TableCell data-id="element-1026">
                      <Badge variant="outline" className={`font-mono text-[8px] px-1 py-0 h-4 border-none ${a.status === 'TERKOORDINASI' ? 'bg-amber-500/10 text-amber-500' : 'bg-blue-500/10 text-blue-500'}`} data-id="element-1027">
                        {a.status}
                      </Badge>
                    </TableCell>
                    <TableCell data-id="element-1028">
                      <span className={`font-mono text-[9px] ${a.sentiment === 'NEGATIF' ? 'text-red-500' : a.sentiment === 'POSITIF' ? 'text-emerald-500' : 'text-muted-foreground'}`} data-id="element-1029">
                        {a.sentiment}
                      </span>
                    </TableCell>
                    <TableCell className="text-right" data-id="element-1030">
                      <Button size="xs" variant="outline" className="h-6 text-[9px] font-mono" onClick={() => setSelectedActor(a)} data-id="element-1031">
                        Lihat Jaringan
                      </Button>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>

      <Dialog open={!!selectedActor} onOpenChange={o => !o && setSelectedActor(null)} data-id="element-1032">
        <DialogContent className="max-w-2xl bg-background border-border" data-id="element-1033">
          <DialogHeader data-id="element-1034">
            <DialogTitle data-id="element-1035">Jaringan: {selectedActor?.name}</DialogTitle>
            <DialogDescription data-id="element-1036">
              Visualisasi koneksi aktor pada klaster {selectedActor?.cluster}
            </DialogDescription>
          </DialogHeader>
          <div className="relative h-[400px] bg-muted/40 rounded border border-border/50 overflow-hidden" data-id="element-1037">
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-1038"></div>

            <svg className="absolute inset-0 w-full h-full" viewBox="0 0 600 400" preserveAspectRatio="xMidYMid meet" data-id="element-1039">
              <g transform="translate(300, 200)" data-id="element-1040">
                <line x1="0" y1="0" x2="-120" y2="-80" stroke="#94a3b8" strokeWidth="1" data-id="element-1041" />
                <line x1="0" y1="0" x2="100" y2="-90" stroke="#94a3b8" strokeWidth="1" data-id="element-1042" />
                <line x1="0" y1="0" x2="130" y2="60" stroke="#94a3b8" strokeWidth="1" data-id="element-1043" />
                <line x1="0" y1="0" x2="-80" y2="100" stroke="#94a3b8" strokeWidth="1" data-id="element-1044" />
                <line x1="0" y1="0" x2="-150" y2="20" stroke="#94a3b8" strokeWidth="1" data-id="element-1045" />
                <line x1="0" y1="0" x2="50" y2="150" stroke="#94a3b8" strokeWidth="1" data-id="element-1046" />
                <line x1="-120" y1="-80" x2="-150" y2="20" stroke="#94a3b8" strokeWidth="1" strokeDasharray="2,2" data-id="element-1047" />
                <line x1="100" y1="-90" x2="130" y2="60" stroke="#94a3b8" strokeWidth="1" strokeDasharray="2,2" data-id="element-1048" />

                <circle cx="0" cy="0" r="22" fill="#f59e0b" stroke="#fff" strokeWidth="2" data-id="element-1049" />
                <text textAnchor="middle" y="4" fontSize="10" fill="#000" fontFamily="monospace" fontWeight="bold" data-id="element-1050">
                  {selectedActor?.name.substring(0, 2).toUpperCase()}
                </text>

                {[{
                x: -120,
                y: -80,
                lbl: 'A1'
              }, {
                x: 100,
                y: -90,
                lbl: 'A2'
              }, {
                x: 130,
                y: 60,
                lbl: 'A3'
              }, {
                x: -80,
                y: 100,
                lbl: 'A4'
              }, {
                x: -150,
                y: 20,
                lbl: 'A5'
              }, {
                x: 50,
                y: 150,
                lbl: 'A6'
              }].map(n => <g key={n.lbl} data-id="element-1051">
                    <circle cx={n.x} cy={n.y} r="14" fill="#1e293b" stroke="#3b82f6" strokeWidth="1.5" data-id="element-1052" />
                    <text x={n.x} y={n.y + 3} textAnchor="middle" fontSize="9" fill="#60a5fa" fontFamily="monospace" data-id="element-1053">
                      {n.lbl}
                    </text>
                  </g>)}
              </g>
            </svg>
            <div className="absolute bottom-2 right-2 font-mono text-[10px] text-muted-foreground" data-id="element-1054">
              7 nodes • 9 edges
            </div>
          </div>
          <div className="flex gap-2 mt-2" data-id="element-1055">
            <Button onClick={() => {
            toast.success('Aktor ditambahkan ke watchlist');
            setSelectedActor(null);
          }} data-id="element-1056">
              Tambah ke Watchlist
            </Button>
            <Button variant="outline" onClick={() => {
            toast.info('Laporan jaringan diekspor');
            setSelectedActor(null);
          }} data-id="element-1057">
              Ekspor Laporan
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <RelatedWorkflow currentStep="Intelijen Aktor" nextSteps={[{
      to: '/bot-detection',
      icon: Users,
      label: 'Cek Aktivitas Bot',
      desc: 'Apakah aktor ini bagian dari klaster terkoordinasi?'
    }, {
      to: '/foreign-influence',
      icon: Globe,
      label: 'Pengaruh Asing',
      desc: 'Cross-ref dengan akun & server luar negeri.'
    }, {
      to: '/case-management',
      icon: FileSearch,
      label: 'Buat Berkas Kasus',
      desc: 'Buka kasus pidana untuk aktor target.'
    }, {
      to: '/response-recommender',
      icon: Megaphone,
      label: 'Counter Narrative',
      desc: 'Buat respons resmi terhadap narasi aktor.'
    }]} data-id="element-1058" />
    </div>;
}